import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Grid, IconButton } from "@mui/material";
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';

import ScreenDropdown from "app/components/common/ScreenDropdown";
import RingChart from "app/components/charts/RingChart";
import PieChart from "app/components/charts/PieChart";
import AgeJobCounts from "./Screen3Graphs/AgeJobCounts";
import RaceJobCounts from "./Screen3Graphs/RaceJobCounts";
import GenderJobCounts from "./Screen3Graphs/GenderJobCounts";
import RegionalConcentrations from "./Screen3Graphs/RegionalConcentrations";
import RegionalMigration from "./Screen3Graphs/RegionalMigration";

import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import screen3_left from "app/assets/Screen3_left.png";
import screen3_right from "app/assets/Screen3_right.png";
import "./Screen3.css";

import { changeScreenOrientation, updateDataSources } from "../../7screen/redux/ScreensCommon/actions";

import { logActivity } from "../redux/api/loggingAPI";
import { CommonScreenConstants, UserActivityConstants } from "api/UserActivityConstants";

import {
  fetchIndustryData,
  fetchAverageDataScreen3,
  fetchAgeData,
  fetchRaceData,
  fetchGenderData,
  fetchRegionalConcentrationData,
  fetchRegionalMigrationData,
  updateIndustryTypeS3,
} from "../../7screen/redux/screen3/actions";

const Screen1NavTitles = ["Demographics", "Maps"];

class Screen3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subMenuIndex: 0,
    };
  }

  changeSubMenu = (i) => {
    this.setState({
      subMenuIndex: i,
    });

    logActivity({
      screen : UserActivityConstants.SCREEN3.NAME,
      action_type : UserActivityConstants.ACTION_TYPES.CLICK,
      action : UserActivityConstants.SCREEN3.ACTIONS.CHANGE_SUB_MENU,
      action_target : Screen1NavTitles[i]
    })
  };

  refreshData() {
    this.props.fetchIndustryData();
    this.props.fetchAverageDataScreen3(
      this.props.regionSelected,
      this.props.industryTypeSelectedS3
    );
    this.props.fetchAgeData(
      this.props.regionSelected,
      this.props.industryTypeSelectedS3,
      this.props.jobTypeSelectedS2
    );
    this.props.fetchRaceData(
      this.props.regionSelected,
      this.props.industryTypeSelectedS3,
      this.props.jobTypeSelectedS2
    );
    this.props.fetchGenderData(
      this.props.regionSelected,
      this.props.industryTypeSelectedS3,
      this.props.jobTypeSelectedS2
    );
    this.props.fetchRegionalConcentrationData(
      this.props.industryTypeSelectedS3
    );
    this.props.fetchRegionalMigrationData(this.props.industryTypeSelectedS3);
  }

  componentDidMount() {
    this.refreshData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.regionSelected !== prevProps.regionSelected) {
      this.refreshData();
    }
    if (prevProps.jobTypeSelectedS2 !== this.props.jobTypeSelectedS2) {
      this.props.fetchAgeData(
        this.props.regionSelected,
        this.props.industryTypeSelectedS3,
        this.props.jobTypeSelectedS2
      );
      this.props.fetchRaceData(
        this.props.regionSelected,
        this.props.industryTypeSelectedS3,
        this.props.jobTypeSelectedS2
      );
      this.props.fetchGenderData(
        this.props.regionSelected,
        this.props.industryTypeSelectedS3,
        this.props.jobTypeSelectedS2
      );
    }
    if (
      prevProps.industryTypeSelectedS3 !== this.props.industryTypeSelectedS3
    ) {
      this.props.fetchAverageDataScreen3(
        this.props.regionSelected,
        this.props.industryTypeSelectedS3
      );
      this.props.fetchAgeData(
        this.props.regionSelected,
        this.props.industryTypeSelectedS3,
        this.props.jobTypeSelectedS2
      );
      this.props.fetchRaceData(
        this.props.regionSelected,
        this.props.industryTypeSelectedS3,
        this.props.jobTypeSelectedS2
      );
      this.props.fetchGenderData(
        this.props.regionSelected,
        this.props.industryTypeSelectedS3,
        this.props.jobTypeSelectedS2
      );
      this.props.fetchRegionalConcentrationData(
        this.props.industryTypeSelectedS3
      );
      this.props.fetchRegionalMigrationData(this.props.industryTypeSelectedS3);
    }
  }

  handleIndustryTypeChange = (event) => {
    const {
      target: { value },
    } = event;
    let industryType = value;

    // log industry change activity here
    logActivity({
      screen : UserActivityConstants.SCREEN3.NAME,
      action_type : UserActivityConstants.ACTION_TYPES.CLICK,
      action : UserActivityConstants.SCREEN3.ACTIONS.CHANGE_INDUSTRY_TYPE,
      action_target : industryType
    })

    this.props.updateIndustryTypeS3(industryType);
    this.props.fetchAverageDataScreen3(this.props.regionSelected, industryType);
    this.props.fetchAgeData(
      this.props.regionSelected,
      industryType,
      this.props.jobTypeSelectedS2
    );
    this.props.fetchRaceData(
      this.props.regionSelected,
      industryType,
      this.props.jobTypeSelectedS2
    );
    this.props.fetchGenderData(
      this.props.regionSelected,
      industryType,
      this.props.jobTypeSelectedS2
    );
    this.props.fetchRegionalConcentrationData(industryType);
    this.props.fetchRegionalMigrationData(industryType);
  };

  handleDataSourceToggle = () => {
    this.props.updateDataSources()
    logActivity({
      screen : UserActivityConstants.SCREEN3.NAME,
      action_type : UserActivityConstants.ACTION_TYPES.CLICK,
      action : UserActivityConstants.COMMON_ACTIONS.TOGGLE_DATA_SOURCE,
      action_target : `${this.props.displayDataSources ? "Hide data source" : "Show data source"}`
    })
  }

  render() {
    var industryTypes = Object.values(this.props.industryData);
    var average_h3_percent_industry = this.props.averageDataScreen3[
      "average_h3_percent_industry"
    ];
    var average_net_migration_industry = this.props.averageDataScreen3[
      "average_net_migration_industry"
    ];
    var average_turnover_rate_industry = this.props.averageDataScreen3[
      "average_turnover_rate_industry"
    ];
    var average_unemployment = this.props.averageDataScreen3[
      "average_unemployment"
    ];
    var representativeness = this.props.averageDataScreen3[
      "representativeness"
    ];
    var countData = {
      data: Object.values(this.props.ageData),
      labels: [
        "Age 65 +",
        "Age 55 to 64",
        "Age 45 to 54",
        "Age 35 to 44",
        "Age 25 to 34",
        "Age 19 to 24",
      ],
    };

    var RING_CHART_DATA = [
      {
        name: "White",
        y: Object.values(this.props.raceData)[0],
        color: "#005898",
      },
      {
        name: "Hispanic",
        y: Object.values(this.props.raceData)[1],
        color: "#6AA4DC",
      },
      {
        name: "African American",
        y: Object.values(this.props.raceData)[2],
        color: "#FFB607",
      },
      {
        name: "Asian",
        y: Object.values(this.props.raceData)[3],
        color: "#FB6A59",
      },
      {
        name: "American Indian",
        y: Object.values(this.props.raceData)[4],
        color: "#DE3E40",
      },
      {
        name: "Two or More Races",
        y: Object.values(this.props.raceData)[5],
        color: "#70898E",
      },
    ];

    var PIE_CHART_DATA = [
      {
        name: "Male",
        y: Object.values(this.props.genderData)[0],
        color: "#6AA4DC",
      },
      {
        name: "Female",
        y: Object.values(this.props.genderData)[1],
        color: "#FB6A59",
      },
    ];

    var regionalConcentrationData = Object.values(
      this.props.regionalConcentrationData
    );
    var regionalMigrationData = Object.values(this.props.regionalMigrationData);
    // regionalMigrationData.push( { code: "AZ", state: "Arizona", emigration: "N/A", immigration: "N/A", net_migration_maps: 0})

    return (
      <div className="screen-wrapper">
        <header className="screen-header">
          <IconButton
              id="data-sources-icon"
              style={{
                color: "white",
                marginLeft: 20,
                marginRight: -60,
                marginTop: -155,
                position: 'relative', // This is required for z-index to work
                zIndex: 1000,
              }}
              onClick={this.handleDataSourceToggle}
            >
              <LibraryBooksIcon className="swap-icon" />
            </IconButton>
          <div className="title">Industry Detail</div>
          <div className="screen-menu">
            {Screen1NavTitles.map((title, i) => (
              <div
                key={i}
                className={`screen-menu-item ${
                  this.state.subMenuIndex === i ? "selected" : ""
                }`}
                onClick={() => {
                  this.changeSubMenu(i);
                }}
              >
                {title}
                <br />
              </div>
            ))}
          </div>
        </header>
        <Grid
          container
          className="screen-content-wrapper screen-content-wrapper-3"
        >
          <Grid
            container
            className="screen-content-grid-3"
            style={{ height: "915px" }}
          >
            <Grid item md={2.4} className="aggregated-metric-wrapper">
              <div
                style={{ backgroundColor: "#005898" }}
                className="rect-shape"
              >
                <span style={{ display: "block" }}>H3 Percent</span>{" "}
                <b>
                  {average_h3_percent_industry
                    ? average_h3_percent_industry + "%"
                    : `NA`}
                </b>
              </div>
            </Grid>
            <Grid item md={2.4} className="aggregated-metric-wrapper">
              <div
                style={{ backgroundColor: "#6AA4DC" }}
                className="rect-shape"
              >
                <span style={{ display: "block" }}>Turnover Rate</span>{" "}
                <b>
                  {average_turnover_rate_industry
                    ? average_turnover_rate_industry
                    : "NA"}
                </b>
              </div>
            </Grid>
            <Grid item md={2.4} className="aggregated-metric-wrapper">
              <div
                style={{ backgroundColor: "#FFB607" }}
                className="rect-shape"
              >
                <span style={{ display: "block" }}>Representativeness</span>{" "}
                <b>{representativeness ? representativeness : "NA"}</b>
              </div>
            </Grid>
            <Grid item md={2.4} className="aggregated-metric-wrapper">
              <div
                style={{ backgroundColor: "#FB6A59" }}
                className="rect-shape"
              >
                <span style={{ display: "block" }}>Net Migration</span>{" "}
                <b>
                  {average_net_migration_industry
                    ? average_net_migration_industry.toLocaleString("en-US")
                    : "NA"}
                </b>
              </div>
            </Grid>
            <Grid
              item
              md={2.4}
              className="aggregated-metric-wrapper"
              style={{ paddingRight: 0 }}
            >
              <div
                style={{ backgroundColor: "#DE3E40" }}
                className="rect-shape"
              >
                <span style={{ display: "block" }}>Unemployment</span>{" "}
                <b>{average_unemployment ? average_unemployment : `NA`}</b>
              </div>
            </Grid>
            {this.state.subMenuIndex === 0 ? (
              <Grid item md={5}>
                <AgeJobCounts
                  industryTypes={industryTypes}
                  industryTypeSelected={this.props.industryTypeSelectedS3}
                  handleIndustryTypeChange={this.handleIndustryTypeChange}
                  countData={countData}
                />
              </Grid>
            ) : (
              <></>
            )}
            {this.state.subMenuIndex === 0 ? (
              <Grid item md={3.5}>
                {RING_CHART_DATA.length != 0 && hasData(RING_CHART_DATA) ? (
                  <RaceJobCounts raceData={RING_CHART_DATA} />
                ) : (
                  <div style={{ textAlign: "center", paddingTop: "400px" }}>
                    {" "}
                    No data available{" "}
                  </div>
                )}
              </Grid>
            ) : (
              <></>
            )}
            {this.state.subMenuIndex === 0 ? (
              <Grid item md={3.5}>
                {PIE_CHART_DATA.length != 0 && hasData(PIE_CHART_DATA) ? (
                  <GenderJobCounts
                    industryType={this.props.industryTypeSelectedS3}
                    pieData={PIE_CHART_DATA}
                  />
                ) : (
                  <div style={{ textAlign: "center", paddingTop: "400px" }}>
                    {" "}
                    No data available{" "}
                  </div>
                )}
              </Grid>
            ) : (
              <></>
            )}
            {this.state.subMenuIndex === 1 ? (
              <Grid item md={6}>
                <RegionalConcentrations
                  industryTypes={industryTypes}
                  industryTypeSelected={this.props.industryTypeSelectedS3}
                  handleIndustryTypeChange={this.handleIndustryTypeChange}
                  regionalConcentrationData={regionalConcentrationData}
                />
              </Grid>
            ) : (
              <></>
            )}
            {this.state.subMenuIndex === 1 ? (
              <Grid item md={6}>
                {regionalMigrationData.length != 0 ? (
                  <RegionalMigration
                    regionalMigrationData={regionalMigrationData}
                  />
                ) : (
                  <div style={{ textAlign: "center" }}> No data available </div>
                )}
              </Grid>
            ) : (
              <></>
            )}

            {/* <Grid item md={5}>
                <img key={1} className="left_placeholder" alt="" src={screen3_left} />
            </Grid>
            <Grid item md={7}>
                <img key={2} className="right_placeholder" alt="" src={screen3_right} />
            </Grid> */}
          </Grid>
        </Grid>
      </div>
    );
  }
}

function hasData(chartData) {
  let hasNodata = true;
  chartData.forEach((elem) => {
    if (elem && elem.y && elem.y.length != 0) {
      hasNodata = false;
    }
  });
  return !hasNodata;
}
function mapStateToProps(state) {
  return {
    industryData: { ...state.Screen3Reducer.industryData },
    averageDataScreen3: { ...state.Screen3Reducer.averageDataScreen3 },
    ageData: { ...state.Screen3Reducer.ageData },
    raceData: { ...state.Screen3Reducer.raceData },
    genderData: { ...state.Screen3Reducer.genderData },
    regionalConcentrationData: {
      ...state.Screen3Reducer.regionalConcentrationData,
    },
    regionalMigrationData: { ...state.Screen3Reducer.regionalMigrationData },
    orientationHorizontal: state.ScreensCommonReducer.orientationHorizontal,
    displayDataSources: state.ScreensCommonReducer.displayDataSources,
    regionSelected: state.Screen1Reducer.regionSelected,
    jobTypeSelectedS2: state.Screen2Reducer.jobTypeSelectedS2,
    industryTypeSelectedS3: state.Screen3Reducer.industryTypeSelectedS3,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      changeScreenOrientation,
      fetchIndustryData,
      fetchAverageDataScreen3,
      updateDataSources,
      fetchAgeData,
      fetchRaceData,
      fetchGenderData,
      fetchRegionalConcentrationData,
      fetchRegionalMigrationData,
      updateIndustryTypeS3,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Screen3);
